import { Box, Text } from '@chakra-ui/react';
import { IconPlus } from '@tabler/icons';
import GenericModal from 'components/modal/genericModal/GenericModal';
import { hierarchyMessages } from 'pages/admin/cadastros/comercial/hierarquia/variables/hierarchyMessages';

interface ModalConfirmCreateHierarchyProps {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export const ModalConfirmCreateHierarchy = ({
	isOpen,
	onConfirm,
	onCancel,
}: ModalConfirmCreateHierarchyProps) => {
	return (
		<GenericModal
			isOpen={isOpen}
			onClose={onCancel}
			onCancel={onCancel}
			onSave={onConfirm}
			title={hierarchyMessages.MODAL_CREATE.TITLE}
			titleIcon={IconPlus}
			titleIconColor='easyRED.300'
			saveButtonText={hierarchyMessages.BUTTONS.CREATE}
			cancelButtonText={hierarchyMessages.BUTTONS.CANCEL}
			maxWidth='500px'
		>
			<Box mt={-6}>
				<Text
					color='gray.500'
					fontSize='sm'
					fontWeight={200}
				>
					{hierarchyMessages.MODAL_CREATE.DESCRIPTION}
				</Text>
			</Box>
		</GenericModal>
	);
};
